module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp1_8017.0178d3e4.png";